import React, { useEffect, useRef, useState } from "react"

/**
 * Bootstrap-5-Collapse als schlanke React-Komponente
 * (Ersatz für react-bootstrap/Collapse - Animation via Bootstrap-Klassen).
 */
export default function Collapse({ in: show, children, className = "" }) {
    const ref = useRef(null)
    const [state, setState] = useState(show ? "show" : "")

    useEffect(() => {
        const el = ref.current
        if (!el) return undefined
        if (show) {
            el.classList.add("showing")
            setState("show")
            const done = () => el.classList.remove("showing")
            el.addEventListener("transitionend", done, { once: true })
            return () => el.removeEventListener("transitionend", done)
        }
        el.classList.add("showing")
        setState("")
        const done = () => el.classList.remove("showing")
        el.addEventListener("transitionend", done, { once: true })
        return () => el.removeEventListener("transitionend", done)
    }, [show])

    return (
        <div
            ref={ref}
            className={`collapse ${state} ${className}`.trim()}
        >
            {children}
        </div>
    )
}